import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {SnackbarProvider} from 'notistack'
import {Column} from 'react-table'
import {AttendClaimUserDocument} from '../../../../model/claimUser.model'
import {
  getAttentionList,
  downloadClaimDocumentsAttentionService,
} from '../../../../services/claimUser.service'
import {useCentral} from '../../../../../../hooks/useCentral'
import {ModalAttendClaim} from '../modal/ModalAttendClaimUser'
import {formatDateDDMMYYYY} from '../../../../../../util/dates'

const TableAttendClaim: FC = () => {
  const {data, setData, loading, setLoading, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useCentral()
  const [showModal, setShowModal] = useState(false)
  const [createdModal, setCreatedModal] = useState(false)
  const [claimToEdit, setClaimToEdit] = useState<AttendClaimUserDocument | any>()

  const getAttendList = async () => {
    setLoading(true)
    const {data: response} = await getAttentionList(
      currentTabItem.idToEdit as any,
      pagination.currentPage,
    )
    if (!response.error) {
      setData(response.data)
      // setPagination({
      //   ...pagination,
      //   totalResults: response.total,
      // })
    }
    setLoading(false)
  }

  const handleEdit = (item: AttendClaimUserDocument) => {
    setClaimToEdit(item)
    setShowModal(true)
    setCreatedModal(false)
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    getAttendList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    setLoading(false)
    getAttendList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])
  const handleDownload = async (props: any) => {
    try {
      const getRow = props.row
      const getArrows = props.data
      const getData = getArrows[getRow.index]
      const response = await downloadClaimDocumentsAttentionService(getData.Id)
      const link = document.createElement('a')
      link.href = response.data.url
      link.download = getData.NombreDocumento + getData.TipoDocumento // Ajusta el nombre del archivo según tus necesidades

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {}
  }

  const columns: Column<AttendClaimUserDocument>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Rquerimiento' />,
      accessor: 'TipoRequerimiento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Responsable' />,
      accessor: 'Responsable_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cargo del Responsable' />,
      accessor: 'Responsable_cargo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Empresa del Responsable' />,
      accessor: 'Responsable_empresa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Telefono del Responsable' />,
      accessor: 'Responsable_telefono',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Email del Responsable' />,
      accessor: 'Responsable_email',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de Atencion' />,
      accessor: 'FechaAtencion',
      Cell: ({...props}) => <div>{formatDateDDMMYYYY(props.row.original.FechaAtencion)}</div>,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Atencion' />,
      accessor: 'Atencion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <div className='d-flex'>
          {isAllowed('ATENDREQUERIMIENTO/DESCARGAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleDownload(props)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/arrows/arr091.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
          {isAllowed('ATENDREQUERIMIENTO/VER') && (
            <div
              className='d-flex justify-content-center flex-shrink-0 ms-3'
              onClick={() => handleEdit(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </div>
      ),
    },
  ]

  return (
    <>
      {isAllowed('ATENDREQUERIMIENTO/LISTAR') && (
        <KTCard shadow className='m-5'>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          <SnackbarProvider />
          {showModal ? (
            <ModalAttendClaim
              show={showModal}
              setShow={setShowModal}
              claimToEdit={claimToEdit}
              getAttentionList={getAttendList}
              created={createdModal}
            />
          ) : (
            <></>
          )}
        </KTCard>
      )}
    </>
  )
}

const TableAttendClaimWrapper = () => {
  return (
    <KTableProvider>
      <TableAttendClaim />
    </KTableProvider>
  )
}

export {TableAttendClaimWrapper}
